import NoFound from "./NoFound";
import NoAccess from "./NoAccess";
import ChangePassword from "./ChangePassword";
import Login from "./Login";
const viewComponents = {
    NoFound,
    NoAccess,
    ChangePassword,
    Login

};   
export default viewComponents;